import { isHttpError } from '@core/http-client'

export type TSentEventError = {
    errorMessage: string
    status?: number
    url?: string
    requestId?: string
}

export const formatSentEventError = (error: unknown): TSentEventError => {
    const sentEventError: TSentEventError = {
        errorMessage: error instanceof Error ? error.message : String(error),
    }

    if (isHttpError(error)) {
        sentEventError.status = error.response.status
        sentEventError.url = error.request.url
        // Lets the backend and Cloudflare find this exact request.
        sentEventError.requestId = error.response.headers.get('x-request-id') ?? undefined
    }

    return sentEventError
}
